import { deleteElegibidad } from '../../config/apiSinToken'

export const deleteLocationById = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/ProjectDevelopmentLocation/deleteLocation?idLocation=${params}`,
  )
  return data
}

export const deleteAssestLossClimate = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/AssetsLossClimate/deleteAsset?idAsset=${params}`,
  )
  return data
}

export const deleteProductionAndLosses = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/ProductionAndLossesByClimate/deleteProductionAndLoss/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.1
export const deleteActivity = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/ProductiveActivitiesPlanning/deleteActivity/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.3
export const deleteBarrier = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/MarketAccessBarriers/deleteBarrier/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.6
export const deleteEnergyUsedProduction = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/EnergyUsedProduction/delete/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.9
export const deleteManagementSoilsPractices = async ({
  IdElegibilityAnswer,
  IdAdaptationPractice,
}) => {
  const data = await deleteElegibidad(
    `api/v1/ManagementSoilsPractices/delete/${IdElegibilityAnswer}/${IdAdaptationPractice}`,
  )
  return data
}

// Funcion para la tabla 4.1 seccion 4
export const deleteGenderActivities = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/GenderActivities/delete/${params}`,
  )
  return data
}

// Funcion para la tabla 5.2 seccion 5
export const deleteAdaptationMeasures = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/AdaptationMeasures/delete/${params}`,
  )
  return data
}

// Funcion para la tabla 5.3 (tableGanttDev) seccion 5
export const deleteImplementationSchedule = async ({
  IdElegibilityAnswer,
  IdImplementationSchedule,
}) => {
  const data = await deleteElegibidad(
    `api/v1/ImplementationSchedule/delete/${IdImplementationSchedule}/${IdElegibilityAnswer}`,
  )
  return data
}

// Funcion para la tabla 5.4 (presupuesto) seccion 5
export const deleteSubprojectBudget = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/SubprojectBudget/delete/${params}`,
  )
  return data
}

// Seccion 6
export const deleteManagementPlanMitigation = async (params) => {
  const data = await deleteElegibidad(
    `api/v1/ManagementPlanMitigations/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Eliminar Formulario ELEGIBILIDAD
 * FECHA: 30-9-2022
 */
export const DeleteElibilityForm = async (idForm, userb2c) => {
  const data = await deleteElegibidad(
    `api/v1/Forms/deleteFormElegibilityById/${idForm}/${userb2c}`,
  )
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Eliminar Irrigation System (Tabla 3.9.7)
 * FECHA: 10-3-2023
 */
export const DeleteIrrigationSystems = async (param) => {
  const data = await deleteElegibidad(
    `api/v1/IrrigationSystems/DeleteIrrigationSystem?IdirrigationSystem=${param}`,
  )
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Eliminar Fertilizer System (Tabla 3.9.8)
 * FECHA: 10-3-2023
 */
export const DeleteUsedFertilizers = async (param) => {
  const data = await deleteElegibidad(
    `api/v1/UsedFertilizers/Delete?IdusedFertilizer=${param}`,
  )
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Eliminar Table 3.9.1
 * FECHA: 10-4-2024
 */
export const DeleteProductiveActivitiesPlanning = async (param) => {
  const data = await deleteElegibidad(
    `api/v1/ProductiveActivitiesPlanning/deleteActivity/form/${param}`,
  )
  return data
}
